import React, { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export const Hero = () => {
  const ref = useRef(null);
  const {
    scrollYProgress
  } = useScroll({
    target: ref,
    offset: ['start start', 'end start']
  });
  // Parallax effects
  const yBg = useTransform(scrollYProgress, [0, 1], ['0%', '20%']);
  const scaleBg = useTransform(scrollYProgress, [0, 1], [1, 0.95]);
  const yText = useTransform(scrollYProgress, [0, 1], ['0%', '-30%']);
  const opacityText = useTransform(scrollYProgress, [0, 0.8], [1, 0]);
  return <section ref={ref} className="relative min-h-screen flex items-center overflow-hidden bg-brand-dark" data-id="element-99">
      {/* Full-width Background Image */}
      <div className="absolute inset-0 z-0" data-id="element-100">
        <motion.div style={{
        y: yBg,
        scale: scaleBg
      }} initial={{
        scale: 1.05,
        opacity: 0,
        filter: 'blur(4px)'
      }} animate={{
        scale: 1,
        opacity: 1,
        filter: 'blur(0px)'
      }} transition={{
        duration: 2,
        ease: [0.16, 1, 0.3, 1]
      }} className="w-full h-full origin-top" data-id="element-101">
          <video autoPlay loop muted playsInline src="https://cdn.magicpatterns.com/uploads/37sJQiE5kyfCpKUHqWsoje/Dispel%20Your%20Tattoo.mp4" className="w-full h-full object-cover object-[70%_center] md:object-center grayscale-[20%]" data-id="element-102" />
        </motion.div>

        {/* Gradients for text readability and cinematic feel */}
        <div className="absolute inset-0 bg-gradient-to-r from-brand-darker via-brand-darker/80 to-transparent w-full md:w-[70%]" data-id="element-103"></div>
        <div className="absolute inset-0 bg-gradient-to-t from-brand-darker via-transparent to-transparent h-full" data-id="element-104"></div>
      </div>

      {/* Content */}
      <motion.div style={{
      y: yText,
      opacity: opacityText
    }} className="relative z-10 max-w-[1400px] mx-auto px-6 md:px-12 w-full pt-32 pb-20" data-id="element-105">
        <div className="max-w-3xl" data-id="element-106">
          <motion.div initial={{
          opacity: 0,
          y: 40,
          filter: 'blur(8px)'
        }} animate={{
          opacity: 1,
          y: 0,
          filter: 'blur(0px)'
        }} transition={{
          duration: 1.2,
          delay: 0.4,
          ease: [0.16, 1, 0.3, 1]
        }} data-id="element-107">
            <h1 className="text-4xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl leading-[1.2] text-brand-light mb-10 md:mb-14 font-medium tracking-tight text-balance" data-id="element-108">
              Détatouage Professionnel en Valais
            </h1>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 1,
          delay: 0.6,
          ease: [0.16, 1, 0.3, 1]
        }} className="flex flex-col sm:flex-row items-start sm:items-center space-y-4 sm:space-y-0 sm:space-x-6 md:space-x-10" data-id="element-109">
            <motion.a href="#contact" whileHover={{
            scale: 1.02,
            boxShadow: '0 0 20px rgba(245,245,240,0.1)'
          }} transition={{
            duration: 0.3,
            ease: 'easeOut'
          }} className="w-full sm:w-auto text-center px-8 md:px-10 py-4 md:py-5 bg-brand-light text-brand-dark rounded-full font-bold uppercase tracking-wider hover:bg-white transition-colors duration-300 text-sm md:text-base" data-id="element-110">
              Réserver une consultation
            </motion.a>
            <a href="#technology" className="group flex items-center space-x-3 text-brand-gray hover:text-brand-light transition-colors duration-300" data-id="element-111">
              <span className="text-sm font-medium uppercase tracking-widest" data-id="element-112">
                Découvrir le traitement
              </span>
              <ArrowRight size={18} className="group-hover:translate-x-2 transition-transform duration-300" data-id="element-113" />
            </a>
          </motion.div>
        </div>
      </motion.div>
    </section>;
};